import React, { Dispatch, SetStateAction } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Typography, Button, Box, Divider } from '@mui/material';
import RoundCheckIcon from '../images/round-check.svg';
import styles from './RegisterHalfConfirmations.module.css';
import { ArrowForward } from '@mui/icons-material';
import FamiliplusProfileCard from './common/FamiliplusProfileCard';

interface RegisterFamiliplusConfirmationProps {
  stepHandler: Dispatch<SetStateAction<number>>;
  currentStep: number;
  profile: any;
}

export const RegisterFamiliplusConfirmation = ({
  stepHandler,
  currentStep,
  profile,
}: RegisterFamiliplusConfirmationProps): JSX.Element => {
  const { t } = useTranslation('component');

  return (
    <>
      <Box sx={{ textAlign: 'center', mb: '45px' }}>
        <Box component="img" src={RoundCheckIcon} alt="" />
        <Typography variant="h2" sx={{ mt: '24px' }}>
          <Trans t={t} components={{ br: <br /> }}>
            {t('RegisterConfirmation.familiplusTitle')}
          </Trans>
        </Typography>
      </Box>

      {profile.familiplusCard && (
        <Box className={styles['cardContainer-familiplus']}>
          <Box className={styles.cardShapeBackground}></Box>
          <FamiliplusProfileCard
            fullName={`${profile.firstName} ${profile.lastName}`}
            cardNumber={profile.familiplusCard}
            numberOfPoints={profile.familiplusCardPoints}
            valueOfPoints={profile.familiplusCardPoints / 100}
            sx={{
              borderRadius: '24px',
              height: '100%',
              position: 'absolute',
              top: 0,
              left: 0,
            }}
          />
        </Box>
      )}

      <Box>
        <Box className={styles.stepBox}>
          <Box className={styles.number}>3</Box>
          {t('Steps.3') + ' ' + t('Form.Optional')}
        </Box>
        <Box className={styles.stepBox}>
          <Box className={styles.number}>4</Box>
          {t('Steps.4') + ' ' + t('Form.Optional')}
        </Box>
      </Box>

      <ConfirmationFooter stepHandler={stepHandler} currentStep={currentStep} />
    </>
  );
};

interface ConfirmationFooterProps {
  stepHandler: Dispatch<SetStateAction<number>>;
  currentStep: number;
}

const ConfirmationFooter = ({ stepHandler, currentStep }: ConfirmationFooterProps): JSX.Element => {
  const { t } = useTranslation('component');

  return (
    <>
      <Divider sx={{ my: '32px' }} />
      <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
        <Button
          variant="contained"
          size="large"
          endIcon={<ArrowForward />}
          onClick={() => stepHandler(currentStep + 0.5)}>
          {t('RegisterConfirmation.NextStep')}
        </Button>
      </Box>
    </>
  );
};
